import React, {useState} from 'react';
import {makeStyles, Stepper, Step, StepLabel, Typography, Button} from '@material-ui/core/';
// REDUX
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// PAGES
import ProcesarSolicitudPortalWeb from '../DatosCiudadanoPortalWebTSE'
import RechazarSolicitudPortalWeb from '../DatosCiudadanoPortalWebTSE/RechazarSolicitudPortalWebTSE/index'
// ESTILOS
import {useStyles} from './style';
import Homonimos from 'pages/solicitudesExtranjero/solicitudesNuevas/SolicitudesEmpadronamiento/homonimos'

// STEPER
const StepperFormPortalWebTSE = (props) => {
    const classes = useStyles(),
        steps =  ['Homónimos','Empadronar / Actualizar', 'Rechazar Solicitud Portal Web',],
        // Step argumento renderiza el componente de forma escalonada a traves de una funcion switch
        // Agregar un case más y case 0 será el componente de homonimos.
        getStepContent = (step) => {
            switch (step) {
                case 0:
                    return <Homonimos cerrarDialogo={props.handleClose} arrayHomonimos={props.arrayHomonimos} showDialogHomonimos={props.open} isPortalWeb={true}/>;
                case 1:
                    return <ProcesarSolicitudPortalWeb {...props} />;
                case 2:
                    return <RechazarSolicitudPortalWeb {...props} />;
                default:
                    return 'Ocurrió un error, Vuelva a recargar la página por favor!';
            }
        };

    return (
        <div className={classes.root}>
            <Stepper className={classes.Margenes} activeStep={props.stepPortalWeb}>
            {/* iterar steps */}
                {steps.map((label, index) => {
                    const stepProps = {};
                    {/* si props.recharzarSoliciutdPortalWeb existe o contenga un valor*/}
                    if(props.rechazarSolicitudPortalWeb){
                        {/* si index es 0, es decir se rechaza desde la primer pantalla entonces el steper no fue completado */}
                        if (index === 0) {
                            stepProps.completed = false;
                        }
                    }
                    return (
                    <Step key={label} {...stepProps}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                    );
                })}
            </Stepper>
                {props.stepPortalWeb === steps.length ? (
                    ""
                ) : (
                    <div>
                        {getStepContent(props.stepPortalWeb)}
                    </div>
                )}
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(StepperFormPortalWebTSE);